import dayjs from 'dayjs';

/**
 * Formats a number as JOD currency with 3 decimal places and thousands separators.
 * Example: 1234.5 -> 1,234.500 JOD
 * @param {number|string} amount 
 * @returns {string}
 */
export const formatMoneyJOD = (amount) => {
    const val = parseFloat(amount || 0);
    return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 3,
        maximumFractionDigits: 3,
    }).format(val) + ' JOD';
};

/**
 * Formats a date string or object into a human-readable format.
 * @param {string|Date|dayjs.Dayjs} date 
 * @param {string} format Default is 'DD/MM/YYYY'
 * @returns {string}
 */
export const formatDate = (date, format = 'DD/MM/YYYY') => {
    if (!date) return '-';
    return dayjs(date).format(format);
};

/**
 * Formats a date string or object into a human-readable date and time.
 * @param {string|Date|dayjs.Dayjs} date 
 * @returns {string}
 */
export const formatDateTime = (date) => {
    if (!date) return '-';
    return dayjs(date).format('DD/MM/YYYY HH:mm');
};
